{
  "fr": {
    "task": {
      "actions": {
        "create": "Tâche",
        "create_and_send": "Créer et envoyer",
        "delete": "Supprimer la tâche",
        "keep_as_draft": "Garder en brouillon",
        "open_in_project": "Ouvrir la tâche dans le projet",
        "remove_from_unit": "Retirer la tâche de cette unité",
        "save_as_draft": "Enregistrer comme brouillon",
        "update": "Modifier la tâche"
      },
      "attributes": {
        "assignments_count": "Assignations",
        "category": "Méthode de clôture",
        "created_at": "Créé le",
        "description": "Description",
        "phase": "Phase",
        "title": "Titre"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Téléversement de document"
      },
      "categories_info": {
        "confirmation": "La personne assignée la coche une fois qu'elle est faite.",
        "upload": "La personne assignée doit téléverser un fichier pour la terminer."
      },
      "confirm": {
        "delete_accept": "Supprimer partout",
        "delete_body": "Cela supprime {count} tâche sur {units}, même si elle est déjà terminée. | Cela supprime les {count} tâches sur {units}, y compris celles déjà terminées.",
        "delete_body_empty": "Cela supprime la tâche.",
        "delete_body_project": "Cela supprime la tâche et sa personne assignée. | Cela supprime la tâche et ses {count} personnes assignées.",
        "delete_cancel": "Garder la tâche",
        "delete_header": "Supprimer « {title} » ?",
        "delete_silent": "Personne n'est notifié, et les notifications déjà envoyées ne sont pas retirées.",
        "publish_body": "Nous créons {tasks} sur {units} et les envoyons aux personnes assignées. Chaque tâche reste sur Ouvert jusqu'à ce qu'elle soit terminée.",
        "publish_body_project": "Nous créons {tasks} dans ce projet et les envoyons aux personnes assignées. Chaque tâche reste sur Ouvert jusqu'à ce qu'elle soit terminée.",
        "publish_header": "Créer et envoyer cette tâche ?",
        "publish_info": "Les personnes assignées reçoivent tout de suite un e-mail. Enregistre-la comme brouillon si tu n'es pas encore prêt à l'envoyer.",
        "remove_from_unit_accept": "Retirer de l'unité",
        "remove_from_unit_body": "Cela retire toutes les personnes assignées à cette tâche dans cette unité. La tâche et ses autres unités restent intactes.",
        "remove_from_unit_customers": "Les clients de cette unité ne la voient plus dans leur portail.",
        "remove_from_unit_header": "Retirer « {title} » de cette unité ?"
      },
      "deep_link": {
        "show_all": "Afficher toutes les tâches",
        "single": "Vous consultez une tâche."
      },
      "empty": {
        "filtered_description": "Rien ne correspond aux filtres que tu as choisis. Efface-les pour voir toutes les tâches.",
        "filtered_description_project": "Rien ne correspond aux filtres que tu as choisis. Efface-les pour voir toutes les tâches de ce projet.",
        "filtered_title": "Aucune tâche ne correspond à tes filtres",
        "none_description": "Crée une tâche et assigne-la à ton équipe ou aux clients d'une ou plusieurs unités. Elle apparaît ici dès que tu l'envoies.",
        "none_description_sup": "Crée une tâche et assigne-la à ton équipe ou à tes clients. Elle apparaît ici dès que tu l'envoies.",
        "none_title": "Pas encore de tâches"
      },
      "filters": {
        "phase_none": "Aucune phase",
        "search": "Rechercher une tâche"
      },
      "form": {
        "category_subtitle": "Choisis comment la personne assignée marque la tâche comme terminée",
        "category_title": "Comment est-elle terminée ?",
        "description_help": "Visible par toutes les personnes qui reçoivent cette tâche.",
        "description_placeholder": "Ajoute des détails ou des instructions",
        "edit_info_assignments": "Tu gères les personnes assignées, les unités et les échéances par personne assignée dans la liste des tâches.",
        "edit_info_assignments_project": "Tu gères les personnes assignées et les échéances par personne assignée dans la liste des tâches.",
        "edit_info_fields": "Tu modifies ici le titre et la description.",
        "edit_info_fields_phase": "Tu modifies ici le titre, la description et la phase.",
        "heading_create": "Nouvelle tâche",
        "heading_update": "Modifier la tâche",
        "phase_help_update": "Chaque unité qui a atteint la nouvelle phase, ou l'a déjà dépassée, voit cette tâche tout de suite. Les unités qui n'y sont pas encore la voient dès qu'elles y arrivent.",
        "phase_help_update_project": "Si ce projet a atteint la nouvelle phase, ou l'a déjà dépassée, ses personnes assignées voient cette tâche tout de suite. Sinon, elles la voient dès que le projet y arrive.",
        "scope_headline": "{count} tâche sera créée et envoyée | {count} tâches seront créées et envoyées",
        "scope_project": "{assignees} dans ce projet",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "Que faut-il faire ?",
        "units_selected": "{selected} sur {count} unité sélectionnée | {selected} sur {count} unités sélectionnées",
        "units_title": "Quelles unités"
      },
      "labels": {
        "assignees_count": "{count} personne assignée | {count} personnes assignées",
        "created_by": "Créé par {name} · {date}",
        "created_on": "Créé le {date}",
        "required": "Ce champ est obligatoire",
        "set_all_assignees": "Définir la personne assignée | Définir les {count} personnes assignées",
        "still_to_do": "{count} encore à faire",
        "tasks_count": "{count} tâche | {count} tâches",
        "units_count": "{count} unité | {count} unités",
        "units_required": "Sélectionnez au moins une unité"
      },
      "toasts": {
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "remove_from_unit": "Tâche retirée de cette unité",
        "update": "Tâche mise à jour"
      }
    }
  }
}
